__turbopack_context__.v({
  "bold": "lcsa9q_bold",
  "cta": "lcsa9q_cta",
  "imageContainer": "lcsa9q_imageContainer",
  "root": "lcsa9q_root",
  "textContainer": "lcsa9q_textContainer",
});
